import { Injectable, signal } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';


@Injectable({
  providedIn: 'root'
})
export class PwaService {
  

  promptEvent: any

  updateAvailable = signal(false)



  constructor(private swUpdate: SwUpdate,
) {
    window.addEventListener('beforeinstallprompt', event => {
      this.promptEvent = event;
    });


    if (this.swUpdate.isEnabled) {

      this.swUpdate.unrecoverable.subscribe((event) => {
        console.error("Unrecoverable error.  Reloading application", event.reason);
        window.location.reload();
      });

      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === "VERSION_READY") {
        
         
          this.updateAvailable.set(true);
        }

      });

      setInterval(async () => {
        //console.log("Checking for update");
        try {

          await this.swUpdate.checkForUpdate();
        }
        catch (error) {
          console.log(error);
        }
      }, 3 * 60 * 1000);
    }
    else {
      console.log("Browser does not support pwa");
    }
  }

  public get versionUpdates() {
    return this.swUpdate.versionUpdates;
  }

  get pwaAvailable(): boolean {
    return this.swUpdate.isEnabled;
  }

  checkForUpdate() {
    this.swUpdate.checkForUpdate();
  }

  async activateUpdate() {
    if (await this.swUpdate.activateUpdate()) {
      window.location.reload();
    }
  }

  promptForInstall() {
   this.promptEvent.prompt();

    this.promptEvent.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the A2HS prompt');
      } else {
        console.log('User dismissed the A2HS prompt');
      }
      this.promptEvent = null;
    });
  }


}
